// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import { put, call, takeEvery } from 'redux-saga/effects';
// import * as firebase from 'firebase/app';

import loginService from './service';
import * as loginActions from './actions';
import * as basketActions from '../../basket/store/actions';
import { updateCartIndicatorSaga } from '../../basket/store/sagas';
import * as types from './actionTypes';
import history from '../../../services/history';

function* loginSaga(payload) {
  const res = yield call(loginService, payload.data);
  const email = res.body.EmailID;
  if (email) {
    // firebase.analytics().logEvent('login', {
    //   method: 'web',
    // });

    if (!payload.isNewCustomer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'login',
        method: 'custom', // sign-up method (google, facebook, custom)
        user_id: `${res.body.CustomerId}`,
      });
    }

    localStorage.setItem('loggedID', res.body.CustomerId);
    localStorage.setItem('token', res.body.Token);
    localStorage.setItem('TradeCustomer', res.body.TradeCustomer);
    localStorage.setItem('PaymentTypeForTradeCustomer', res.body.PaymentType);
    localStorage.setItem('isBookshop', res.body.IsBookshop === true ? 1 : 0);
    yield put(basketActions.getCartId());
    yield call(updateCartIndicatorSaga);

    if (payload.toCheckout) {
      history.push('/checkout');
    } else {
      history.push('/account');
    }
  } else {
    yield put(loginActions.loginFailed('Check your email or password.'));
  }
}

const loginSagas = [
  takeEvery(types.LOGIN_REQUEST, loginSaga),
];

export default loginSagas;
